import { apiClient, type ApiRequestInit } from './api.js';

export async function getAllEmployees<T>(init?: ApiRequestInit, limit?: number): Promise<{ data: T[] }> {
  const data: T[] = [];
  const cursors = new Set<string>();
  let url = `/api/v1/employees${limit ? `?limit=${limit}` : ''}`;
  for (;;) {
    const page = await apiClient.get<{
      data: T[];
      pagination?: { has_more: boolean; next_cursor: string | null };
    }>(url, init);
    data.push(...page.data);
    if (!page.pagination?.has_more) return { data };
    const cursor = page.pagination.next_cursor;
    if (!cursor || cursors.has(cursor)) throw new Error('Could not load the complete employee list. Refresh and try again.');
    cursors.add(cursor);
    url = `/api/v1/employees?${limit ? `limit=${limit}&` : ''}cursor=${encodeURIComponent(cursor)}`;
  }
}
